export const getCreditSafeVatParams = (
  vat: string,
  fallbackCountry?: string,
): { countries: string; vatNo: string } => {
  const normalized = vat.replaceAll(' ', '').toUpperCase()

  if (/^[A-Za-z]{2}/.test(normalized)) {
    return { countries: normalized.slice(0, 2), vatNo: normalized.slice(2) }
  }

  return { countries: (fallbackCountry ?? '').toUpperCase(), vatNo: normalized }
}

export const getCreditSafeAddressLine = ({
  simpleValue,
  street,
}: {
  simpleValue?: null | string
  street?: null | string
}) => {
  if (!simpleValue) return ''
  if (!street) return simpleValue

  const streetIndex = simpleValue.indexOf(street)

  if (streetIndex === -1) return simpleValue

  return `${simpleValue.slice(0, streetIndex)} ${street}`.trim()
}
